var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.SourceCurrency"),
                          prop: "sourceCurrency",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.SourceCurrency"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.sourceCurrency,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "sourceCurrency", $$v)
                            },
                            expression: "queryParams.sourceCurrency",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("QuotationCustomerLang.TargetCurrency"),
                          prop: "targetCurrency",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            placeholder: _vm.$t(
                              "QuotationCustomerLang.TargetCurrency"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.targetCurrency,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "targetCurrency", $$v)
                            },
                            expression: "queryParams.targetCurrency",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return _vm._l(_vm.dropCols, function (col, index) {
                return _c("el-table-column", {
                  key:
                    "col_" +
                    index +
                    "_" +
                    col.prop +
                    "_" +
                    (col.width || "auto"),
                  attrs: {
                    prop: col.prop,
                    label: col.label,
                    width: col.width || "auto",
                    fixed: col.fixed || false,
                    align: "center",
                    "class-name": "item",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            col.prop === "effectiveFrom" ||
                            col.prop === "effectiveTo"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("timeFilters")(
                                          scope.row[col.prop],
                                          { dateFormat: "DD/MM/YYYY" }
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              : col.prop === "status"
                              ? [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row[col.prop] == 1
                                            ? "success"
                                            : "info",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.STATUS_ENABLED_NUM.bjGet(
                                                scope.row[col.prop]
                                              )
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("timeFilters")(
                                        scope.row[col.prop],
                                        scope.row[col.prop]
                                      )
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              })
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }